const { protocol, hostname } = window.location;

export let baseApiUrl: string;

if (process.env.NODE_ENV === "development") {
  const local = false;

  if (local) {
    baseApiUrl = `${protocol}//${hostname}:5000`;
  } else {
    const [clientName] = hostname.split(".");
    baseApiUrl = `https://${clientName}.menulegal.pt`;
  }
} else {
  baseApiUrl = `${protocol}//${hostname}`;
  baseApiUrl = baseApiUrl.replace("www.", "");
}
